module.exports = __webpack_public_path__ + "assets/img/06bb8de634b8c8fa6df9c8f550b3239c.png";